import { Grid, IconButton, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { theme } from 'config';

export const Container = styled(Grid)({
  position: 'relative',
  marginLeft: 'auto',
  WebkitTapHighlightColor: 'transparent',

  [theme.breakpoints.down('sm')]: {
    marginLeft: '0',
  },
});

export const TitleWrapper = styled(Grid)({
  display: 'flex',
  cursor: 'pointer',
  alignItems: 'center',
});

export const Title = styled(Typography)({
  marginRight: '5px',
});

export const Value = styled(Typography)({
  textDecoration: 'underline',
  color: theme.palette.secondary.main,
  fontSize: '14px',
  textTransform: 'lowercase',

  '&::first-letter': {
    textTransform: 'capitalize',
  },
});

export const IconWrapper = styled(IconButton)(
  {
    '&:focus': {
      backgroundColor: 'transparent',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  ({ expand }) => ({
    transform: `rotate(${expand !== 'true' ? '180deg' : '0'})`,
  })
);

export const List = styled(Grid)({
  position: 'absolute',
  backgroundColor: '#fff',
  width: '100%',
  border: '2px solid #EBEBEB',
  zIndex: '2',
});

export const Item = styled(Typography)({
  padding: '5px',
  cursor: 'pointer',
  textTransform: 'lowercase',

  '&:nth-of-type(even)': {
    backgroundColor: '#F3F3F3',
  },
  '&:hover': {
    backgroundColor: '#DEDEDE',
  },
  '&::first-letter': {
    textTransform: 'capitalize',
  },
});
